var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.getDialogQueue),function(dialog,index){return _c('v-dialog',{key:index,attrs:{"persistent":"","max-width":"290"},model:{value:(dialog.enabled),callback:function ($$v) {_vm.$set(dialog, "enabled", $$v)},expression:"dialog.enabled"}},[_c('Dialog',{attrs:{"dialog":dialog}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }